
import PublicNavigation from "./PublicNavigation";

function Navigation() {


  return <PublicNavigation />;
}
export default Navigation;
